// @flow

import React from 'react';
import { Link, NavLink } from 'react-router-dom';

const Header = () =>
  (<header className="site-header">
    <div className="site-header__logo">
      <Link to="/" title="Home">
        <svg role="img" aria-labelledby="site-header-logo" focusable="false">
          <title id="site-header-logo">
            Ferguson Voices | A Moral Courage Project
          </title>
          <use xlinkHref="#logo" />
        </svg>
      </Link>
    </div>
    <div className="site-header__sponsors">
      <p className="site-header__sponsors-title h3 h3--tiny theme--white">
        Presented by
      </p>
      <ul className="site-header__sponsors-list list">
        <li className="site-header__sponsors-list-item list__item">
          <a
            href="http://proof.org/"
            target="_blank"
            rel="noopener noreferrer"
            className="svg svg--sponsor-proof"
          >
            <svg
              role="img"
              aria-labelledby="site-header-sponsor-proof"
              focusable="false"
            >
              <title id="site-header-sponsor-proof">
                Proof: Media for Social Justice&copy;
              </title>
              <use xlinkHref="#sponsor-proof" />
            </svg>
          </a>
        </li>
        <li className="site-header__sponsors-list-item list__item">
          <a
            href="https://www.udayton.edu/artssciences/ctr/hrc/"
            target="_blank"
            rel="noopener noreferrer"
            className="svg svg--sponsor-u-of-dayton"
          >
            <svg
              role="img"
              aria-labelledby="site-header-sponsor-u-of-dayton"
              focusable="false"
            >
              <title id="site-header-sponsor-u-of-dayton">
                Human Rights Center : University of Dayton, Ohio
              </title>
              <use xlinkHref="#sponsor-u-of-dayton" />
            </svg>
          </a>
        </li>
      </ul>
    </div>
    <div className="site-header__navigation">
      <h2 className="visually-hidden">Secondary Navigation</h2>
      <ul className="site-header__navigation-list list center--vertically h3 h3--small links--white-on-dark">
        <li className="site-header__navigation-list-item list__item hide-on-tablet">
          <NavLink to="/about" activeClassName="is-active">
            About<span className="hide-on-small-desktop">
              {' '}the Project &amp; Exhibit
            </span>
          </NavLink>
        </li>
        <li className="site-header__navigation-list-item list__item">
          <Link to={{ hash: '#subscribe-to-podcast' }}>
            Subscribe<span className="hide-on-small-desktop">
              {' '}to the Podcast
            </span>
          </Link>
        </li>
        <li className="site-header__navigation-list-item list__item">
          <Link to={{ hash: '#share' }}>Share</Link>
        </li>
      </ul>
    </div>
  </header>);

export default Header;



// WEBPACK FOOTER //
// ./screens/App/components/Header/index.js